import Customer from './Customer.vue'
import CustomerView from './view/CustomerView.vue'
import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import DashboardView from "./view/dashboard/DashboardView";
import AddressList from "./view/addresses/AddressList";
import Terms from "./view/terms/Terms";
import ActivitiesView from "./view/activities/ActivitiesView";
import ReceiptList from "./view/receipts/ReceiptList";
import Notes from "./view/notes/Notes";
import InvoicesList from "./view/invoices/InvoicesList";
import Attachments from "@/modules/customer/view/attachments/Attachments";
import BalanceView from "./view/balance/BalanceView";
import Optin from "@/modules/customer/view/optin/Optin";
import Contracts from "@/modules/customer/view/contracts/Contracts"
import SettlementsList from "./view/settlements/SettlementsList";
import BidsList from "@/modules/customer/view/bids/BidsList";
import LotsList from "./view/purchased-lots/LotsList.vue";
import FavoriteLotList from "./view/favorite-lots/LotsList.vue";
import RelationsList from "@/modules/customer/view/relations/RelationsList";
import RelatedToList from "@/modules/customer/view/relations/RelatedToList.vue";
import VendorCharges from "./view/vendor-charges/VendorCharges";

const routes = [
  {
    path: 'customers',
    name: 'customers',
    component: Customer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'customers/view/:id',
    name: 'customers.view',
    component: CustomerView,
    redirect: 'customers/view/:id/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'customers.dashboard',
        component: DashboardView
      },
      {
        path: 'addresses',
        name: 'customers.addresses',
        component: AddressList
      },
      {
        path: 'notes',
        name: 'customers.notes',
        component: Notes
      },
      {
        path: 'terms',
        name: 'customers.terms',
        component: Terms
      },
      {
        path: 'vendorCharges',
        name: 'customers.vendorCharges',
        component: VendorCharges
      },
      {
        path: 'optin',
        name: 'customers.optin',
        component: Optin
      },
      {
        path: 'attachments',
        name: 'customers.attachments',
        component: Attachments
      },
      {
        path: 'contracts',
        name: 'customers.contracts',
        component: Contracts
      },
      {
        path: 'invoices',
        name: 'customers.invoices',
        component: InvoicesList
      },
      {
        path: 'settlements',
        name: 'customers.settlements',
        component: SettlementsList
      },
      {
        path: 'deposits',
        name: 'customers.deposits',
        component: BalanceView
      },
      {
        path: 'activities',
        name: 'customers.activities',
        component: ActivitiesView
      },
      {
        path: 'receipts',
        name: 'customers.receipts',
        component: ReceiptList
      },
      {
        path: 'bids',
        name: 'customers.bids',
        component: BidsList
      },
      {
        path: 'purchased-lots',
        name: 'customers.purchasedLots',
        component: LotsList
      },
      {
        path: 'favorite-lots/:sale_no?',
        name: 'customers.favoriteLots',
        component: FavoriteLotList
      },
      {
        path: 'relations',
        name: 'customers.relations',
        component: RelationsList
      },
      {
        path: 'related_to',
        name: 'customers.related_to',
        component: RelatedToList
      }
    ]
  },];

MenuService.addMenuItem(new MenuItem('/customers', i18n.t('Customers'), 5, 'user-tie', [], 'view_customer'));

export {routes}
